module.exports = __webpack_public_path__ + "img/habib.c49bde06.png";